import React, { useContext, useState, useEffect } from "react";
import ModuleSidebar from "../../components/ModuleSidebar/ModuleSidebar";
import { useLanguage } from "../../LanguageProvider";
import { TbFolders, TbPlus } from "react-icons/tb";
import "./TaskManagement.css";
import Calendar from "../../components/Calendar/Calendar";
import AddPanelModal from "./AddPanelModal/AddPanelModal";
import AddBoardModal from "./AddBoardModal/AddBoardModal";
import { GeneralContext } from "../../GeneralProvider";

export default function TaskManagement() {
  const { getTranslation } = useLanguage();
  const {
    getAllPanels,
    panels,
    handleAddNewPanel,
    handleNewAddBoard,
    handleDeleteBoard,
    handleUpdatePanelTitle,
    handleDeletePanel,
    selectedProjectID,
    getUserAuthorizations,
    selectedTaskByKronos,
    setSelectedTaskByKronos,
  } = useContext(GeneralContext);
  const [isAddPanelModalOpen, setIsAddPanelModalOpen] = useState(false);
  const [isAddBoardModalOpen, setIsAddBoardModalOpen] = useState(false);
  const [selectedSubmenu, setSelectedSubmenu] = useState(null);
  const [selectedPanelId, setSelectedPanelId] = useState("");
  const [menus, setMenus] = useState([]);
  const [projectAuthorization, setProjectAuthorization] = useState(null);
  const [autoTask, setAutoTask] = useState(null);

  const handleSubmenuClick = (submenu) => {
    setSelectedSubmenu(submenu);
    setSelectedPanelId(submenu.panelId);
    setSelectedTaskByKronos("");
  };

  const fetchAuthorizations = async () => {
    const res = await getUserAuthorizations();

    if (res?.result?.length > 0) {
      const matchedProject = res?.result?.find(
        (item) => item.projectID === selectedProjectID
      );

      if (matchedProject) {
        setProjectAuthorization(matchedProject.authorizations);
      } else {
        setProjectAuthorization(null);
      }
    }
  };

  useEffect(() => {
    fetchAuthorizations();
  }, [selectedProjectID]);

  useEffect(() => {
    if (panels?.length > 0) {
      const formattedMenus = panels.map((panel) => ({
        title: panel.panelTitle,
        id: panel.panelId,
        icon: <TbFolders size={20} />,
        submenu: panel.boards.map((board) => ({
          title: board.boardTitle,
          id: board.boardId,
          createdBy: board.boardCreatedBy,
          tasks: board.tasks,
          panelId: board.panelId,
        })),
        createdBy: panel.panelCreatedBy,
      }));

      setMenus([{ sections: formattedMenus }]);

      if (selectedSubmenu !== null) {
        const updatedPanel = panels.find((panel) =>
          panel.boards.some((board) => board.boardId === selectedSubmenu.id)
        );
        if (updatedPanel) {
          const updatedBoard = updatedPanel.boards.find(
            (board) => board.boardId === selectedSubmenu.id
          );

          if (updatedBoard) {
            setSelectedSubmenu({
              title: updatedBoard.boardTitle,
              id: updatedBoard.boardId,
              createdBy: updatedBoard.boardCreatedBy,
              tasks: updatedBoard.tasks,
            });
          }
        }
      }
    } else {
      setMenus([]);
    }
  }, [panels]);

  useEffect(() => {
    if (selectedTaskByKronos && panels?.length > 0) {
      for (const panel of panels) {
        for (const board of panel.boards) {
          const foundTask = board.tasks.find(
            (task) => task.taskId === selectedTaskByKronos
          );
          if (foundTask) {
            setSelectedSubmenu({
              title: board.boardTitle,
              id: board.boardId,
              createdBy: board.boardCreatedBy,
              tasks: board.tasks,
            });
            setSelectedPanelId(panel.panelId);
            setAutoTask(foundTask);
            return;
          }
        }
      }
    }
  }, [selectedTaskByKronos, panels]);

  const handleOpenAddPanelModal = () => setIsAddPanelModalOpen(true);
  const handleCloseAddPanelModal = () => setIsAddPanelModalOpen(false);

  const handleOpenAddBoardModal = (id) => {
    setSelectedPanelId(id);
    setIsAddBoardModalOpen(true);
  };
  const handleCloseAddBoardModal = () => {
    setIsAddBoardModalOpen(false);
  };

  if (panels?.length > 0) {
    return (
      <>
        <div className="task-management-container">
          <ModuleSidebar
            contextMenuRenameOnClick={handleUpdatePanelTitle}
            contextMenuDeleteOnClick={handleDeletePanel}
            deleteMessage={getTranslation("panelDeleteWarning")}
            addEntitiy={handleOpenAddBoardModal}
            onRightClick={(id)=>setSelectedPanelId(id)}
            title={
              <div
                style={{
                  width: "100%",
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {getTranslation("panels")}
                <TbPlus onClick={handleOpenAddPanelModal} />
              </div>
            }
            checkPermission={projectAuthorization?.authorizations === "all" || projectAuthorization?.authorizations?.panels === "all" || projectAuthorization?.authorizations?.panels?.some((auth) => auth.id === selectedPanelId && auth.authorization !== "read")}
            menus={menus}
            onSubmenuClick={handleSubmenuClick}
            selectedSubmenu={selectedSubmenu?.id}
            projectAuthorization={projectAuthorization}
          />
          <div className="task-management-content">
            <div className="task-management-inner-content">
              {selectedSubmenu !== null && (
                <Calendar
                  panels={panels}
                  board={selectedSubmenu}
                  selectedPanelId={selectedPanelId}
                  propTasks={selectedSubmenu?.tasks || []}
                  setSelectedSubmenu={setSelectedSubmenu}
                  setSelectedPanelId={setSelectedPanelId}
                  projectAuthorization={projectAuthorization}
                  autoTask={autoTask}
                />
              )}
            </div>
          </div>
        </div>
        <AddPanelModal
          isOpen={isAddPanelModalOpen}
          onClose={handleCloseAddPanelModal}
          onCreate={(title) => handleAddNewPanel(title)}
        />

        <AddBoardModal
          isOpen={isAddBoardModalOpen}
          onClose={handleCloseAddBoardModal}
          onCreate={(title) => handleNewAddBoard(selectedPanelId, title)}
        />
      </>
    );
  } else {
    return (
      <div className="task-management-container">
        <div className="content">
          <div className="task-management-inner-container">
            <button
              className="action-button"
              onClick={handleOpenAddPanelModal}
            >
              {getTranslation("addPanel")}
            </button>
            {" "}
            <span className="task-management-title">
              {getTranslation("panelAddedInfo")}
            </span>
          </div>
        </div>
        <AddPanelModal
          isOpen={isAddPanelModalOpen}
          onClose={handleCloseAddPanelModal}
          onCreate={(title) => handleAddNewPanel(title)}
        />
      </div>
    );
  }
}
